import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createGelleryImage, updateGelleryImage, getGelleryImage, deleteGelleryImages } from '../../ReduxToolkit/Slice/Gallery/Images';
import { Link } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import CommanTable from '../../components/Table/CommanTable';
import { getcategory } from '../../ReduxToolkit/Slice/Gallery/Category';


function GelleryImage() {
  const dispatch = useDispatch();
  const closeButtonRef = useRef(null); // Ref to the close button
  const { status, images } = useSelector((state) => state.image);
  const { categorys } = useSelector((state) => state.category);
  const [GelleryImage, setGelleryImage] = useState(null);
  const [title, setTitle] = useState("");
  const [categoryId, setcategoryId] = useState("");

  // create
  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData();
    formData.append('GelleryImage', GelleryImage === null ? "" : GelleryImage);
    formData.append('title', title);
    formData.append('categoryId', categoryId);
    dispatch(createGelleryImage(formData));
    setGelleryImage(null);
    setTitle("");
    closeButtonRef.current.click(); // Programmatically click the close button
  };
  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getGelleryImage())
      dispatch(getcategory())
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (GelleryImageid) => {
    const Isconfirmed = window.confirm("Are you sure! you want delete this Image?")
    if (Isconfirmed) {
      dispatch(deleteGelleryImages(GelleryImageid))
    };

  }
  // single data fetch
  const [updateButton, setupdateButton] = useState("d-none")
  const [SubmitButton, setSubmitButton] = useState("")
  const [selectedId, setSelectedId] = useState(null);
  const handlid = (id) => {
    const selecteGelleryImage = images.data.find(GelleryImage => GelleryImage._id === id);
    setTitle(selecteGelleryImage.title);
    setGelleryImage(selecteGelleryImage.GelleryImage);
    setcategoryId(selecteGelleryImage.categoryId);
    setSelectedId(id);
    if (selecteGelleryImage) {
      setupdateButton("")
      setSubmitButton("d-none")
    }
    else { }
  };
  // update
  const handleEdit = () => {
    const formData = new FormData();
    formData.append('GelleryImage', GelleryImage === null ? "" : GelleryImage);
    formData.append('title', title);
    formData.append('categoryId', categoryId);
    dispatch(updateGelleryImage({ selectedId, formData }));
    setGelleryImage(null);
    setTitle("");
  }
  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }


  const preprocessData = (data) => {
    return data.map(item => ({
      ...item,
      CategoryName: item.category ? item.category.CategoryName : 'not defined category delete and upload again',
    }));
  };

  const columns = [
    { label: "Title", accessor: "title" },
    { label: "Category", accessor: "CategoryName" },
    { label: "Date", accessor: "createdAt", formatter: formatDate },
  ];

  return (
    <>
      <div>
        <ToastContainer />
        <div className='d-flex justify-content-between my-3'>
          <h3>Image</h3>
          <Link to="/pressrealse"> <button className='btn btn-sm bg-primary text-white'>Press Realse</button></Link>
          <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal"><i className='bi bi-plus-circle-fill'></i> Add Image </button>
        </div>

        <CommanTable
          columns={columns}
          data={preprocessData(images.data || [])}
          status={status}
          onDelete={handleDelete}
          onEdit={handlid} 
          databstarget="#exampleModal"
          model="modal"
        />
      </div>

      {/* Modal  */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Upload GelleryImage
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form action="" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="mb-3 col-lg-12">
                    <label htmlFor="title" className="form-label">
                      Image Title
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      id="title"
                      name="title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Title"
                    />
                  </div>
                  <div className="mb-3 col-lg-12">
                    {/* <img src={thumbnail} className='img-fluid rounded' alt="" /> */}
                    <label htmlFor="GelleryImage" className="form-label">
                      Gellery Image
                    </label>
                    <input
                      type="file"
                      required
                      className="form-control"
                      id="thumbnail"
                      name="thumbnail"
                      // value={thumbnail}
                      onChange={(e) => setGelleryImage(e.target.files[0])}
                    />
                  </div>
                  <div className="mb-3 col-lg-12">
                    <label htmlFor="ImageCategory" className="form-label">
                      Select Category
                    </label>
                    <select name="" className='form-control' id="" value={categoryId} onChange={(e) => setcategoryId(e.target.value)}>
                      <option value="" selected>Select Category</option>
                      {categorys.data && categorys.data.map((item) => (
                        <option value={item._id} key={item._id} className='form-control'>{item.CategoryName}</option>
                      ))}
                    </select>

                  </div>
                  <div className={`modal-footer ${SubmitButton}`}>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      ref={closeButtonRef}
                    >
                      Close
                    </button>
                    <button type="submit" className={`btn btn-primary`}>
                      Upload
                    </button>
                  </div>
                </div>
              </form>
              <div className={`modal-footer ${updateButton} `}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" onClick={handleEdit} className={`btn btn-primary`} data-bs-dismiss="modal"  >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GelleryImage;
